import { SelectOption } from '../components/inputs/input.models';

export const ALL_REGIMES: SelectOption[] = [
  { value: 601, display: 'General de Ley Personas Morales' },
  { value: 603, display: 'Personas Morales con Fines no Lucrativos' },
  { value: 605, display: 'Sueldos y Salarios e Ingresos Asimilados a Salarios' },
  { value: 606, display: 'Arrendamiento' },
  { value: 607, display: 'Régimen de Enajenación o Adquisición de Bienes' },
  { value: 608, display: 'Demás ingresos' },
  {
    value: 610,
    display: 'Residentes en el Extranjero sin Establecimiento Permanente en México',
  },
  { value: 611, display: 'Ingresos por Dividendos (socios y accionistas)' },
  { value: 612, display: 'Personas Físicas con Actividades Empresariales y Profesionales' },
  { value: 614, display: 'Ingresos por Intereses' },
  { value: 615, display: 'Régimen de los ingresos por obtención de premios' },
  { value: 616, display: 'Sin obligaciones fiscales' },
  {
    value: 620,
    display: 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
  },
  { value: 621, display: 'Incorporación Fiscal (RIF) — solo contribuyentes antiguos' },
  { value: 622, display: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras' },
  { value: 623, display: 'Opcional para Grupos de Sociedades' },
  { value: 624, display: 'Coordinados' },
  {
    value: 625,
    display:
      'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas',
  },
  { value: 626, display: 'Régimen Simplificado de Confianza (RESICO)' },
];

export const ALL_USE: SelectOption[] = [
  { value: 'G01', display: 'Adquisición de mercancías' },
  { value: 'G02', display: 'Devoluciones, descuentos o bonificaciones' },
  { value: 'G03', display: 'Gastos en general' },

  { value: 'I01', display: 'Construcciones' },
  { value: 'I02', display: 'Mobiliario y equipo de oficina por inversiones' },
  { value: 'I03', display: 'Equipo de transporte' },
  { value: 'I04', display: 'Equipo de cómputo y accesorios' },
  { value: 'I05', display: 'Dados, troqueles, moldes, matrices y herramental' },
  { value: 'I06', display: 'Comunicaciones telefónicas' },
  { value: 'I07', display: 'Comunicaciones satelitales' },
  { value: 'I08', display: 'Otra maquinaria y equipo' },

  { value: 'D01', display: 'Honorarios médicos, dentales y gastos hospitalarios' },
  { value: 'D02', display: 'Gastos médicos por incapacidad o discapacidad' },
  { value: 'D03', display: 'Gastos funerales' },
  { value: 'D04', display: 'Donativos' },
  {
    value: 'D05',
    display: 'Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)',
  },
  { value: 'D06', display: 'Aportaciones voluntarias al SAR' },
  { value: 'D07', display: 'Primas por seguros de gastos médicos' },
  { value: 'D08', display: 'Gastos de transportación escolar obligatoria' },
  {
    value: 'D09',
    display: 'Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones',
  },
  { value: 'D10', display: 'Pagos por servicios educativos (colegiaturas)' },

  { value: 'P01', display: 'Por definir' },

  { value: 'S01', display: 'Sin efectos fiscales' },

  { value: 'CP01', display: 'Pagos' },
];
